import * as Config from '@/config'

export const inputFileAttributeToPostParam = (inputData: any[]) => {
  return inputData;
}

// TODO: 変換系多いので共通化
export const decodeAttributeParams = (attributes: any[], query: any): any => {
  const inputAttributes = {} as any;
  for (const attribute of attributes) {
    const queryValue = query.attributes[attribute.id];
    if (!queryValue) continue;
    if (Config.ATTRIBUTE_CODES.includes(attribute.attribute_kind_code)) {
      if (!queryValue.attribute_value) {
        const arrayValues = [];
        for (const [index, value] of Object.entries(queryValue)) {
          const arrayValue = value as any;
          const option = attribute.attribute_options.find((o: any) => o.code === arrayValue.attribute_code && o.option === arrayValue.attribute_value);
          if (option)
            arrayValues.push(createAttributeOptionValue(option.id, arrayValue.attribute_code, arrayValue.attribute_value));
        }
        inputAttributes[attribute.id] = arrayValues;
      } else {
        const option = attribute.attribute_options.find((o: any) => o.code === queryValue.attribute_code && o.option === queryValue.attribute_value);
        if (option)
          inputAttributes[attribute.id] = createAttributeOptionValue(option.id, queryValue.attribute_code, queryValue.attribute_value);
      }
    } else {
      inputAttributes[attribute.id] = queryValue.attribute_value;
    }
  }
  return inputAttributes;
}

export const inputAttributeOptionValue = (attributeOption: any) => {
  return createAttributeOptionValue(attributeOption.id, attributeOption.code, attributeOption.option);
}
// TODO: 値の持ち方検討→selectにはoption_idで持っておいてget/postの際にcode_valueで検索
export const createAttributeOptionValue = (attribute_option_id: any, attribute_code: any, attribute_value: any) => {
  return attribute_option_id + Config.SPLIT_CODE + attribute_code + Config.SPLIT_CODE + attribute_value;
}

export const inputAttributeToPostParam = (attributes: Array<any>, data: any, dataMap: Map<string, any> | undefined = undefined): any => {
  const inputAttributes = {} as any;
  if (!data.attributes) return inputAttributes;
  for (const attribute of attributes) {
    const inputValue = data.attributes[attribute.id];
    if (!inputValue || inputValue.length === 0)
      continue;
    const dataAttributeValue = dataMap?.get(attribute.id) || undefined;
    if (Config.ATTRIBUTE_CODES.includes(attribute.attribute_kind_code)) {
      const values: any[] = [];
      if (Array.isArray(inputValue)) {
        for (const check of inputValue) {
          const [option_id, code, value] = check.split(Config.SPLIT_CODE);
          const setValue = {attribute_code: code, attribute_value: value} as any;
          if (dataAttributeValue) {
            const existsData = existsDataAttributeValue(code, value, dataAttributeValue);
            if (existsData) setValue["id"] = existsData.id;
          }
          values.push(setValue);
        }
        inputAttributes[attribute.id] = values;
      } else {
        const [option_id, code, value] = inputValue.split(Config.SPLIT_CODE);
        const setValue = {attribute_code: code, attribute_value: value} as any;
        if (dataAttributeValue) {
          const existsData = existsDataAttributeValue(code, value, dataAttributeValue);
          if (existsData) setValue["id"] = existsData.id;
        }
        inputAttributes[attribute.id] = setValue;
      }
    } else {
      inputAttributes[attribute.id] = {attribute_value: inputValue};
      if (dataAttributeValue) {
        inputAttributes[attribute.id]["id"] = dataAttributeValue.id
      };
    }
  }
  return inputAttributes;
}

export const existsDataAttributeValue = (attribute_code: string, attribute_value: string, dataAttributeValue: any): any => {
  if (Array.isArray(dataAttributeValue)) {
    for (const check of dataAttributeValue) {
      if (attribute_code === check.attribute_code && attribute_value ===  check.attribute_value)
        return check;
    }
  } else {
    if (attribute_code === dataAttributeValue.attribute_code && attribute_value ===  dataAttributeValue.attribute_value)
      return dataAttributeValue;
  }
  return undefined;
}

export const convertToKeyMap = (datas: Array<any>, key: string): Map<string, any> => {
  const map = new Map();
  for (const data of datas) {
    if (map.has(data[key])) {
      const value = map.get(data[key]);
      if (Array.isArray(value)) {
        value.push(data);
      } else {
        const array = [value, data];
        map.set(data[key], array);
      }
    } else {
      map.set(data[key], data);
    }
  }
  return map;
}

export const getNestedValue = (data: any): any => {
  if (typeof data === "object")
    return getNestedValue(data[Object.keys(data)[0]]);
  else
    return data;
}

export const getTabIndex = (tabs: any[],tabId: string | undefined) => {
  return tabId ? tabs.findIndex((tab: any) => parseInt(tabId) === tab.id) : 0;
}

export const attributesNewUrl = (projectCategoryId: any) => {
  if (projectCategoryId)
    return `/progress/${projectCategoryId}/new/attributes`;
  else
    return "";
}
export const attributesEditUrl = (projectCategoryId: any, dataId: any, tabId: any = undefined) => {
  if (projectCategoryId && dataId && tabId)
    return `/progress/${projectCategoryId}/${dataId}/attributes/${tabId}/edit`;
  else if (projectCategoryId && dataId)
    return `/progress/${projectCategoryId}/${dataId}/attributes/edit`;
  else
    return "";
}
export const attributesDetailUrl = (projectCategoryId: any, dataId: any, tabId: any = undefined) => {
  if (projectCategoryId && dataId && tabId)
    return `/progress/${projectCategoryId}/${dataId}/attributes/${tabId}`;
  else if (dataId)
    return `/progress/${projectCategoryId}/${dataId}/attributes`;
  else
    return "";
}
export const attributesCopyUrl = (projectCategoryId: any, dataId: any) => {
  if (projectCategoryId && dataId)
    return `/progress/${projectCategoryId}/${dataId}/attributes/copy`;
  else
    return "";
}
export const applyAreaListUrl = (projectCategoryId: any, dataId: any) => {
  if (projectCategoryId && dataId)
    return `/progress/${projectCategoryId}/${dataId}/apply_areas`;
  else
    return "";
}
export const applyAreaListEditUrl = (projectCategoryId: any, dataId: any) => {
  if (projectCategoryId && dataId)
    return `/progress/${projectCategoryId}/${dataId}/apply_areas/edit`;
  else
    return "";
}
export const filesNewUrl = (projectCategoryId: any, dataId: any) => {
  if (projectCategoryId && dataId)
    return `/progress/${projectCategoryId}/${dataId}/files/new`;
  else
    return "";
}
export const filesEditUrl = (projectCategoryId: any, dataId: any, fileId: any) => {
  if (projectCategoryId && dataId && fileId)
    return `/progress/${projectCategoryId}/${dataId}/files/edit/${fileId}`;
  else
    return "";
}
export const filesListUrl = (projectCategoryId: any, dataId: any) => {
  if (projectCategoryId && dataId)
    return `/progress/${projectCategoryId}/${dataId}/files`;
  else
    return "";
}

export const formatPrice = (number: number) => {
  const formatter = new Intl.NumberFormat('ja-JP');
  return formatter.format(number);
}

/* DBから取得したエリア一覧（ツリー含む）からエリアを探す */
export const getArea = (areas: any[], id: number): any | null => {
  for (const area of areas) {
    const result = getAreaById(area, id);
    if (result) {
      return result;
    }
  }
  return null;
}

/* ツリーのエリアデータから子エリアを探す */
export const getAreaById = (area: any, id: number): any | null => {
  if (area.id == id) {
    return area;
  }
  if (area.children) {
    for (const child of area.children) {
      const result = getAreaById(child, id);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

const findNodeById = (tree: any, targetId: number, path = []): any | null => {
  // Base case: if the current node is the target node, return it along with the path
  const object = (({ ['children']: _, ...rest }) => rest)(tree);
  if (tree.id === targetId) {
    return { node: tree, path: path.concat(object) };
  }

  // Recursive case: search in the children of the current node
  if (tree.children) {
      for (const child of tree.children) {
          const result = findNodeById(child, targetId, path.concat(object));
          if (result) {
              return result;
          }
      }
  }

  // If the target ID is not found in the current node or its children, return null
  return null;
}

export const getTreeDepth = (node: any, depth = 0): number => {
  if (!node.children) {
      return depth;
  }
  return Math.max(...node.children.map((child: any) => getTreeDepth(child, depth + 1)));
}

export const getFullAreas = (salesProductId: number, areas: any[]) => {
  for (const area of areas) {
    const result = findNodeById(area, salesProductId);
    if (result) {
      return result.path;
    }
  }
  return [];
}